import styles from './Template.module.scss'
import ServicesFV from 'components/services/common/ServicesFV'
import About from 'components/services/common/About'
import KeyElements, { KeyElementsItem } from './components/KeyElements/KeyElements'
import ImportanceOfDesignSystem from './components/ImportanceOfDesignSystem/ImportanceOfDesignSystem'
import DesignIssuesSolutions from './components/DesignIssuesSolutions/DesignIssuesSolutions'
import ProcessDS from 'components/services/common/ProcessDS'
import Faq from 'components/services/common/Faq'
import { designSystemFaqList } from 'components/common/schema/data/faqs/design-system'
import RelatedPosts from 'components/services/common/RelatedPosts'
import type { RelatedPostsItem } from 'components/services/common/RelatedPosts/RelatedPosts'
import FooterCTA from 'components/common/FooterCTA'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '#' },
  { name: 'デザインシステム構築支援', url: '#' },
]

const ServicesFVList = {
  category: 'デジタルプロダクトデザイン',
  title: (
    <>
      <span>デ</span>
      <span>ザ</span>
      <span>イ</span>
      <span>ン</span>
      <span>シ</span>
      <span>ス</span>
      <span>テ</span>
      <span>ム</span>
      <span>構</span>
      <span>築</span>
      <span>支</span>
      <span>援</span>
    </>
  ),
  text: (
    <>
      デザイン原則の定義、スタイルガイド作成、UIデザインの最適化、UIコンポーネント設計からフロントエンド開発まで、デザインシステム構築の総合支援
    </>
  ),
  imgSrc: '/img/services/services_fv_ds.webp',
  alt: 'デザインシステム構築支援',
}

const aboutList = [
  {
    title: 'デザインシステムとは',
    text: 'デザインシステムとは、デジタルプロダクトの一貫した体験をデザインするためのルールや、運用効率化などを目的としたパターン、実現のための一連のリソースなどを総合したものを指します。標準的な定義は難しいですが、大きくは組織におけるデザインの標準やプロセスを改善する取り組みと言えます。基本的にはデザイン原則などのルールをまとめたガイドラインと、UIデザインの一貫性を保つためのコンポーネントライブラリなどが含まれています。',
  },
  {
    title: '私たちの強み',
    text: 'これまでの私たちの知見を活かし、デザインシステム構築のサポートを提供します。お客さまのチームが自立的にデザインシステムを維持・発展させる能力を獲得できるよう内製化支援も可能です。これにより、長期的かつ持続可能なデザイン品質の向上と開発効率の最適化を実現します。',
  },
]

const keyElementsItems: KeyElementsItem[] = [
  {
    title: 'デザイン原則',
    description: 'プロダクトの核となる「らしさ」や「重要なことはなにか？」を定義・明文化したもの',
    src: '/img/services/designsystem_element01.webp',
  },
  {
    title: 'デザインガイドライン',
    description: 'デザインシステムのルールを記載したもの。レイアウトのルールや、コンポーネントの使用方法など',
    src: '/img/services/designsystem_element02.webp',
  },
  {
    title: 'コンポーネントライブラリ',
    description: 'デザインパターンをコンポーネント化したFigmaのAssetsや、それと同期するReactライブラリなど',
    src: '/img/services/designsystem_element03.webp',
  },
  {
    title: '各種リソース',
    description: 'デザインシステムを運用していく上で必要なデザインファイルやドキュメントなど',
    src: '/img/services/designsystem_element04.webp',
  },
]

const relatedPostsList: RelatedPostsItem = {
  sectionTitle: 'デザインシステム構築支援の関連記事',
  relatedPosts: [
    {
      title: 'デザインシステムとは？内容や作り方、運用方法を解説します',
      link: 'https://www.i3design.jp/in-pocket/what-is-designsystem/',
      thumbnail: 'https://www.i3design.jp/in-pocket/wp-content/uploads/2022/05/designsystem_smn.png',
      day: '2025年10月28日',
      category: 'UI/UXデザイン',
    },
    {
      title: '効率化とコスト削減を叶えるデザインシステムの力：企業が知っておくべきポイント',
      link: 'https://www.i3design.jp/in-pocket/designsystem-efficiency-costreduction/',
      thumbnail: 'https://www.i3design.jp/in-pocket/wp-content/uploads/2025/02/designsystem_point-1.png',
      day: '2025年10月14日',
      category: 'UI/UXデザイン',
    },
    {
      title: '外部ベンダーとデザインシステム構築をするメリットと実際の運用イメージ',
      link: 'https://www.i3design.jp/in-pocket/build-design-system-with-vendors/',
      thumbnail: 'https://www.i3design.jp/in-pocket/wp-content/uploads/2025/02/designsystem_merit.png',
      day: '2025年10月14日',
      category: 'UI/UXデザイン',
    },
    {
      title: 'プロダクト開発の効率と一貫性を高める！デザインシステムの導入ステップと成功のポイント',
      link: 'https://www.i3design.jp/in-pocket/how-to-implement-design-system/',
      thumbnail: 'https://www.i3design.jp/in-pocket/wp-content/uploads/2024/10/thumbnail_DesignSystem.png',
      day: '2025年10月14日',
      category: 'UI/UXデザイン',
    },
  ],
}

const Design_system: React.FC = () => {
  return (
    <>
      <ServicesFV ServicesFVEach={ServicesFVList} paths={paths} />
      <About list={aboutList} />
      <div className={styles.backGround}>
        <KeyElements KeyElementsItems={keyElementsItems} />
      </div>
      <ImportanceOfDesignSystem />
      <div className={styles.line}>
        <DesignIssuesSolutions />
      </div>
      <div className={styles.line}>
        <ProcessDS />
      </div>
      <div className={styles.line}>
        <Faq FaqEach={[designSystemFaqList]} />
      </div>
      <div className={styles.backGroundGray}>
        <RelatedPosts RelatedPostsEach={[relatedPostsList]} />
      </div>
      <FooterCTA />
    </>
  )
}

export default Design_system
